<template>
    <div>
        <Hero :title="$t('solutions.title')" :lead="$t('our_services.lead')" />

        <div v-if="serviceCategories && serviceCategories.length" class="sm:pt-12 pb-16 sm:pb-24 md:pb-28">
            <SectionServices :services="serviceCategories" />
        </div>

        <div v-if="serviceCategories && serviceCategories.length" class="container sm:pb-10">
            <FeatureCard
                v-for="(category, i) in serviceCategories"
                :key="`service-category-${category.id}`"
                :slug="category.slug"
                :title="category.title"
                :illustration="category.image"
                rounded-t-r
                :details="category.services"
                :reversed="i % 2 === 1"
                with-contact-button
            >
                <div v-html="category.content"></div>
            </FeatureCard>
        </div>

        {{/* Contact form */}}
        <div class="sm:container mt-12 md:-mt-12">
            <ContactForm display-as-card class="light-card-shadow--under-md mb-16 md:mb-20" />
        </div>
    </div>
</template>

<script>
import Hero from '@/components/Heroes/Hero';
import SectionServices from '@/components/Sections/SectionServices/SectionServices';
import FeatureCard from '@/components/Cards/FeatureCard/FeatureCard';
import ContactForm from '@/components/Forms/ContactForm';

export default {
    name: 'Services',
    components: {
        Hero,
        SectionServices,
        FeatureCard,
        ContactForm,
    },
    async asyncData({ $axios, error }) {
        let serviceCategories = null;

        try {
            await Promise.all([$axios.$get('/service')])
                .then(([serviceRes]) => {
                    if (serviceRes.success === 1) {
                        serviceCategories = serviceRes.data;
                    }
                })
                .catch((err) => {
                    return error({ statusCode: err.response.status, message: err.response.statusText });
                });
        } catch (err) {
            console.log(err);
        }

        return {
            serviceCategories,
        };
    },
    head() {
        return {
            title: this.$getOgTitle(this.$t('solutions.title')),
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.$t('solutions.title')),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.$t('solutions.title')),
                },
            ],
        };
    },
};
</script>

<style scoped></style>
